export default __webpack_public_path__ + "static/media/cropStageBackground.bfbe5a07.png";